<template>
  <span :style="`color: ${data.deadline[1]}`">{{ data.deadline[0] }}</span>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>